import { TranslateService } from '@ngx-translate/core';

// ****************************************************************
// i18n Translation for Facades
// ****************************************************************

export type TranslateFn = (
  defaultValue: string,
  key: string,
  params?: Record<string, unknown>
) => string;

/**
 * Accessor to ngx-translate service lookups
 */
export const translateWithDefaults =
  (translate: TranslateService, enableLog = false): TranslateFn =>
  (
    defaultValue: string,
    key: string,
    params?: Record<string, unknown>
  ): string => {
    const allKeys = key.replace(/\s+/g, '').split(','); // This will remove all whitespace

    // Find "most recent" translation
    let value = '';
    let selectedKey = '';
    let missingKey = key;

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < allKeys.length; i++) {
      if (!value && allKeys[i]) {
        selectedKey = allKeys[i];
        value =
          (params
            ? translate.instant(selectedKey, params)
            : translate.instant(selectedKey)) || '';

        // If ngx/translate returns the key, it means the translation is missing
        if (value === selectedKey) {
          value = '';
          missingKey = selectedKey;
        }
      }

      if (!value && enableLog)
        console.error(`i18n: Missing translation for key: ${missingKey}`);
    }

    return value || defaultValue;
  };

export const buildTranslateFn = (
  translate: TranslateService,
  enableLog = false
): TranslateFn => translateWithDefaults(translate, enableLog);
